import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

const PAYPER_BAR_DEFAULT_ROOT_NODE = 'payper-reading-bar-root'

function mountApp(elementId = PAYPER_BAR_DEFAULT_ROOT_NODE) {
  const container = document.getElementById(elementId)

  if (!container) {
    console.error(`Element with ID '${elementId}' not found`)
    return
  }

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

export { mountApp }

if (process.env.NODE_ENV !== 'library') {
  mountApp()
}
